import type from '../actions/types';
import { DocumentState } from '../../models/interfaces';
import { ActionType } from '../../../../models/types';

const INITIAL_STATE: DocumentState = {
  selectedDocumentType: {},
  listDocuments: [],
  listDocumentsBkp: [],
  listDocumentsMissing: [],
  isLoading: true,
  total: 0,
}

function reducer(state: DocumentState = INITIAL_STATE, action: ActionType) {
  switch (action.type) {
    case type.SET_SELECTED_DOCUMENTS_TYPE:
      return {
        ...state,
        listDocuments: action.payload
      };
    case type.SET_LIST_DOCUMENTS:
      return {
        ...state,
        listDocuments: action.payload
      };
    case type.SET_LIST_DOCUMENTS_BKP:
      return {
        ...state,
        listDocumentsBkp: action.payload
      };  
    case type.SET_LIST_DOCUMENTS_MISSING:
      return {
        ...state,
        listDocumentsMissing: action.payload
      };  
    case type.SET_LOADING_DOCUMENTS:
      return {
        ...state,
        isLoading: action.payload
      };
    case type.SET_TOTAL_DOCUMENTS:
      return {
        ...state,
        total: action.payload
      };
    default:
      return state;
  }
}

export default reducer;